module.exports = __webpack_public_path__ + "img/guest-buck-icon.9cc3ff1f.png";